import React from 'react';
const IconActionPhoto = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3V14H9.52L12.04 17H19V19H5V16H3V21H21V3H3ZM19 15H12.97L10.45 12H5V5H19V15Z" fill="#2D2E2E"/>
<path d="M15.25 11C16.4926 11 17.5 9.99264 17.5 8.75C17.5 7.50736 16.4926 6.5 15.25 6.5C14.0074 6.5 13 7.50736 13 8.75C13 9.99264 14.0074 11 15.25 11Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionPhoto;